import { registerDynamicForm } from "@/utils/dynamicFormRegistry";

const NEGOTIATION_MODULE = "negotiation_module";

export function registerDynamicForms() {
  registerDynamicForm({
    modelName: "negotiation",
    modes: ["add", "edit"],
    requiresModule: NEGOTIATION_MODULE,
    customFormKey: "negotiation:negotiation",
    autonomous: true,
    component: () => import("./NegotiationForm.vue"),
  });
}
